// extracted by mini-css-extract-plugin
module.exports = {"collapse":"q9qVV","collapse-body":"B8VEe","btn":"-EJfR","wrapper":"vZIpw"};